import React, { PropsWithChildren } from "react";

import { css, cx } from "@emotion/css";
import MuiCard from "@mui/material/Card";

import { useStyles } from "@/hooks/useStyles.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { AtomProps, StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";

export type BaseCardProps = PropsWithChildren<{
  ref?: React.Ref<HTMLDivElement>;
}>;

export type CardProps = AtomProps<BaseCardProps, StyleClasses<"root">>;

export const Card: React.FC<CardProps> = ({ id, className, classes, children, ...props }) => {
  const styles = useStyles(makeStyles);

  return (
    <MuiCard id={id} elevation={0} className={cx(styles.root, className, classes?.root)} {...props}>
      {children}
    </MuiCard>
  );
};

const makeStyles = (theme: Theme) => ({
  root: css({
    padding: theme.spacing(0),
    overflow: "clip",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
    },
    "&:focus": {
      boxShadow: "none",
    },
    ">:last-child": {
      paddingBottom: theme.spacing(8),
    },
  }),
});
